import { useTranslation } from "@msuite/ui/localization";
import { Tag } from "@msuite/ui/tag";
import { IncomingInvoiceApprovalStateTag } from "../incoming-invoice-approval-state-tag";
import type { ApprovalRow } from "./approval-row";

/** Props Interface */
interface ApprovalStateCellProps {
	approval: ApprovalRow;
}

/**
 * The approval's state — or, for an undecided default approval while a sole approver decides the
 * invoice, that it is no longer needed. Whose turn it is shows on the row itself, which the table
 * highlights.
 */
export function ApprovalStateCell({ approval }: ApprovalStateCellProps) {
	/** Context */
	const { t } = useTranslation();

	/** Guard */
	if (!approval.isRequired && approval.state === "pending") {
		return (
			<Tag
				size="xs"
				color="gray"
				variant="plain"
			>
				{t("incoming_invoices.handover.not_required")}
			</Tag>
		);
	}

	/** Render */
	return <IncomingInvoiceApprovalStateTag state={approval.state} />;
}
